import { observer } from 'mobx-react-lite';
import StyleSettingsBlock from './StyleSettingsBlock';
import { StyleSettingsBlockProps, StyleSettingsBlockValueProps } from './types';

export type { StyleSettingsBlockProps, StyleSettingsBlockValueProps };
export default observer(StyleSettingsBlock);
